import React from "react";
import { generateCloudinaryImageUrl, getStyles, splitName } from "../../utils/common-function";
import { UserCardProps } from "./userCard.types";
import Ellipse from "./../../assets/images/Ellipse.svg";
import VerifiedIcon from "../svgImages/verifiedIcon";
import mixpanel from "../../services/mixpanelService";
import useHeadToHead from "../../services/hooks/useHeadToHead";
import { useHistory } from "react-router-dom";

const UserCard: React.FC<UserCardProps> = (props: UserCardProps) => {
  const history = useHistory();
  // const impactScore = formatNumberWithUnits(props.user?.impactScore || 0);
  const { headToHeadData, battleStatus } = useHeadToHead();

  const isUserInBattle =
    battleStatus === "currentHeadToHeadBattle" &&
    (headToHeadData?.player1Stashlink?.user?.id === props.user?.id || headToHeadData?.player2Stashlink?.user?.id === props.user?.id);

  // const openShareModal = () => {
  //   props.setIsShareModalOpen && props.setIsShareModalOpen(true);
  // };

  const { firstName, lastName } = splitName(props.user?.fullName || "");

  const styles = getStyles(props.impactScoreLevel);

  return (
    <div className="relative w-full flex flex-col items-center">
      <div className="relative w-full aspect-video">
        {!props.showIcons && (
          <div className="absolute w-full top-4 flex justify-center z-10">
            <div className="font-secondary font-extrabold inter-I text-white text-13.77px backdrop-blur-5 tracking-0.964px w-105.93 h-33.105 py-8.21 px-17.87 flex items-center previewRotate justify-center leading-none rounded-8.21 border-1.39 border-white bg-black/30 shadow-previewShadow text-shadow-custom uppercase">
              Preview
            </div>
          </div>
        )}
        <img src={generateCloudinaryImageUrl(props.user?.profilePhoto || "", "750", "496")} alt={props.user?.fullName} />
        <div className="h-20 absolute bottom-0 w-full bg-gradient-to-t from-black from-0% via-black/40 via-40% to-black/0 to-100%"></div>
        {/* <div className="absolute bottom-0 h-full w-full" style={{height: "26%", background: "linear-gradient(hsla(0, 0%, 0%, 0) 0%,  hsla(0, 0%, 0%, 0.002) 1.8%,  hsla(0, 0%, 0%, 0.008) 4.8%,  hsla(0, 0%, 0%, 0.021) 9%,  hsla(0, 0%, 0%, 0.042) 13.9%,  hsla(0, 0%, 0%, 0.075) 19.8%,  hsla(0, 0%, 0%, 0.126) 27%,  hsla(0, 0%, 0%, 0.194) 35%,  hsla(0, 0%, 0%, 0.278) 43.5%,  hsla(0, 0%, 0%, 0.382) 53%,  hsla(0, 0%, 0%, 0.541) 66%,  hsla(0, 0%, 0%, 0.738) 81%,  hsl(0, 0%, 0%) 100%)"}} /> */}
      </div>
      <div className="text-center">
        {props.showIcons && (
          <>
            {isUserInBattle ? (
              <span onClick={() => history.push(`/headToHead`)} className="absolute top-3 left-[14px] rounded-lg bg-primary-l3 p-[2px]">
                <div className="flex flex-row items-center justify-center gap-x-[1px]">
                  <img
                    src={headToHeadData?.player1Stashlink?.user?.profilePhoto}
                    alt={headToHeadData?.player1Stashlink?.user?.fullName}
                    className="object-cover w-[31px] h-[28px] rounded-tl-[6px] rounded-bl-[6px] rounded-tr-[2px] rounded-br-[2px]"
                  />
                  <img
                    src={headToHeadData?.player2Stashlink?.user?.profilePhoto}
                    alt={headToHeadData?.player2Stashlink?.user?.fullName}
                    className="object-cover w-[31px] h-[28px] rounded-tr-[6px]  rounded-br-[6px] rounded-tl-[2px] rounded-bl-[2px]"
                  />
                </div>
                <div className="flex flex-row items-center justify-center gap-x-1">
                  <span className="font-normal text-[11px] font-secondary">LIVE</span>
                  <img src={Ellipse} alt="ellipse" className="w-[6px] h-[6px] animate-pulse" />
                </div>
              </span>
            ) : (
              <div />
              // <span onClick={() => mixpanel.track("hero-impact-score-clicked")} className="absolute top-3 left-0">
              //   <ImpactBadge
              //     impact={impactScore}
              //     isImpactIconRequired
              //     setIsUserProfileModalOpen={props.setIsUserProfileModalOpen}
              //     impactScoreLevel={props.impactScoreLevel}
              //   />
              // </span>
            )}
            {/* <div className="p-0.5 bg-black/40 rounded-full flex justify-center items-center absolute top-3 right-3 backdrop-filter-blur h-7 w-7">
              <img
                src={ShareIcon}
                alt={ShareIcon}
                onClick={() => {
                  mixpanel.track("hero-share-clicked");
                  openShareModal();
                }}
              />
            </div> */}
          </>
        )}
        <div className="w-full h-9 py-2 pb-0 left-0 bottom-0 absolute justify-center items-end gap-1 inline-flex">
          <h1
            onClick={() => mixpanel.track("hero-name-clicked")}
            className="break-words w-fit text-28px font-primary font-extrabold z-10 px-2 -mt-10 items-start inline-block  capitalize leading-tight-29.54"
            style={{ color: styles.levelColor }}>
            {firstName}{" "}
            <span className="inline-block">
              {lastName}
              {props.user?.isPublicProfile && (
                <VerifiedIcon color={styles.levelColor} className="ml-1.5 w-3 h-3 inline-block align-middle relative -top-2" />
              )}
            </span>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
